import { render, staticRenderFns } from "./Systemstats.vue?vue&type=template&id=0b98dfa4&scoped=true&"
import script from "./Systemstats.vue?vue&type=script&lang=js&"
export * from "./Systemstats.vue?vue&type=script&lang=js&"
import style0 from "./Systemstats.vue?vue&type=style&index=0&id=0b98dfa4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b98dfa4",
  null
  
)

export default component.exports